/*
 * Copyright (c) 2025 CalAmp Corp. All Rights Reserved
 */
import {useMutation} from 'react-query';
import {loadAllDeviceFiles} from '@ion/core/src/services/Connect';
import {createMutationResult} from '@ion/query/src/utils/helpers';

export type useGetFileIdsResult = {
  loadFileIds: (params: Params, callbacks) => void;
  isLoading: boolean
}

interface Params {
  fileName: string;
  accountId: number;
  includeSubGroups: boolean;
}

/**
 * Provides a utility hook to fetch files for a provided file name.
 */
export const useGetFileIds = (): useGetFileIdsResult => {
  const mutation = useMutation(async(queryParams: Params) => {
    const {accountId, includeSubGroups, fileName} = queryParams;
    const params = {
      accountId,
      includeSubGroups,
      pageSize : 100,
      sortOn   : ['-name'],
      filterOn : {name: fileName}
    };
    const results = await loadAllDeviceFiles(params);
    return results?.map(({id}) => id);
  });
  
  return createMutationResult(
    mutation, {
      loadFileIds : mutation.mutate,
      isLoading   : mutation.isLoading
    }
  ) as useGetFileIdsResult;
};

export default useGetFileIds;
